module.exports = __webpack_public_path__ + "static/media/dinesafe-web.77f43bb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dinesafe-web.png
// module id = 112
// module chunks = 0